// @ts-nocheck

import { createSelector } from 'reselect';

import { selectKLOrientationPaginationIndex } from '../misc';

const selectKLOrientationStepsProps = createSelector([selectKLOrientationPaginationIndex], (paginationIndex) => ({
  paginationIndex,
}));

export default selectKLOrientationStepsProps;
